export default __webpack_public_path__ + "3c324f8d591cad4e5857615bac6f8dca.png";